import React, { useEffect, useMemo, useState } from 'react'
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Role_permission() {

    const [listDefaultRoles, setListDefaultRoles] = useState([]);
    const [selectedRoleId, setSelectedRoleId] = useState(0);
    const [selectedRoleName, setSelectedRoleName] = useState('');
    const [allPermissions, setAllPermissions] = useState([]);
    const [assignedPermissions, setAssignedPermissions] = useState([]);
    const [newRoleName, setNewRoleName] = useState('');
    const [newRoleDescription, setNewRoleDescription] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [membretype, setMembertype] = useState(false);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if(memtype==='free'){
            setMembertype(true);
        }
        fetchRoles();
    }, []);
    const selectedRole = (role) => {

        setSelectedRoleId(role.primary_key);
        setSelectedRoleName(role.role_name);
        document.getElementById('selectedrolename').textContent = role.role_name;
        document.getElementById('roledescription').textContent = role.description;

        $.ajax({
            type: 'POST',
            url: 'getRolePermissions.php',

            data: { role_id: role.primary_key },
            dataType: "json",
            success: function (result) {

                // const parsed = JSON.parse(result);
                const parsed = result;
                if (parsed.status === "success") {
                    setAllPermissions(parsed.all_permissions);
                    setAssignedPermissions(
                        parsed.assigned_permissions.map(id => Number(id))
                    );
                }
            }
        });
    };

    const groupedPermissions = useMemo(() => {
        return allPermissions.reduce((acc, perm) => {
            if (!acc[perm.permission_group]) {
                acc[perm.permission_group] = [];
            }

            acc[perm.permission_group].push(perm);
            return acc;
        }, {});
    }, [allPermissions]);

    const togglePermission = (permissionId) => {

        setAssignedPermissions(prevPermissions => {

            if (prevPermissions.includes(permissionId)) {
                return prevPermissions.filter(id => id !== permissionId);
            } else {
                return [...prevPermissions, permissionId];
            }

        });

    };

    const savePermissions = () => {

        if (!selectedRoleId) {
            alert("Please select a role first.");
            return;
        }
        console.log(assignedPermissions);
        $.ajax({
            type: 'POST',
            url: 'updateRolePermissions.php',
            data: {
                role_id: selectedRoleId,
                permissions: assignedPermissions
            },
            //traditional: true, // IMPORTANT for array sending
            // dataType: "json",
            success: function (result) {
                console.log(result);
                // const parsed = JSON.parse(result);
                const parsed = result;

                if (parsed.status === "success") {
                    showAlert("Permissions updated successfully!");
                } else {
                    alert(parsed.message);
                }
            }
        });
    };

    function openaddnewRolearea() {
        $('.addrolesection').css('display', 'block')
    }

    function clsoerolemodal() {
        $('.addrolesection').css('display', 'none')
    }

    function addRole() {

        if (!newRoleName.trim()) {
            showAlert('Please insert a role name');
            return;
        }

        // 🔥 Check duplicate against existing roles
        const roleExists = listDefaultRoles.some(
            role => role.role_name.toLowerCase() === newRoleName.trim().toLowerCase()
        );

        if (roleExists) {
            showAlert('Role name already exists.');
            return;
        }

        $.ajax({
            type: 'POST',
            url: 'addNewRole.php',
            dataType: "json",
            data: {
                role_name: newRoleName.trim(),
                role_description: newRoleDescription,
                company_id: localStorage.getItem('mem_company_id')
            },
            success: function (parsed) {

                if (parsed.status === "success") {

                    showAlert("Role added successfully!");

                    // 🔥 Clear form

                    // 🔥 Refresh role list
                    fetchRoles();
                    selectedRole({
                        primary_key: parsed.role_id,
                        role_name: newRoleName,
                        description: newRoleDescription
                    });

                    // 3️⃣ Clear form
                    setNewRoleName('');
                    setNewRoleDescription('');

                } else {
                    showAlert(parsed.message);
                }
            }
        });
    }

    const fetchRoles = () => {

        var company_id = localStorage.getItem('mem_company_id');

        $.ajax({
            type: 'POST',
            url: 'getAllDefaultroles.php',
            data: { companyId: company_id },
            dataType: "json",
            success: function (result) {

                console.log(result)
                try {
                     const parsedResult = result;
                    //const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setListDefaultRoles(parsedResult);
                    } else {
                        showAlert('No default role found for your company.');
                        setListDefaultRoles([]);
                    }
                } catch (e) {
                    showAlert('Failed to load role data.');
                    setListDefaultRoles([]);
                }
            }
        });
    };

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
     const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Role & Permissions</h2>

                </div>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_one_third mt-50'>
                            <div className='rol_list'>
                                <ul>
                                    {listDefaultRoles.map((role) => (
                                        <li key={role.primary_key}>
                                            <button
                                                onClick={() => selectedRole(role)}
                                                className={role.system_role == 1 ? 'system_role_btn' : ''}
                                            >
                                                {role.role_name}  
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                                <div className='fullwidth pull_left mt-30'>
                                    <button className='editbtn' onClick={openaddnewRolearea}>Add New Role</button>
                                </div>
                            </div>
                            <div className='addrolesection'>
                                <div className='fullwidth pull_left'>
                                    <button className='contentclosebtn pull_right' onClick={clsoerolemodal}>X</button>
                                </div>
                                <div className='vl_dsh_formnholder'>
                                    <div className='formfield noborder autoheight normalview'>
                                        <label>Add New Role</label>
                                        <input
                                            type="text"
                                            value={newRoleName}
                                            onChange={(e) => setNewRoleName(e.target.value)}
                                        />
                                    </div>
                                    <div className='formfield noborder autoheight normalview'>
                                        <label>Add Role Description</label>
                                        <textarea
                                            value={newRoleDescription}
                                            onChange={(e) => setNewRoleDescription(e.target.value)}
                                        ></textarea>
                                    </div>
                                    <div className='fullwidth pull_left'>
                                        <button className='editbtn' onClick={addRole}>Add Role</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_third mt-50'>
                            <div className='role_options'>
                                <h3 id="selectedrolename"></h3>
                                <p id="roledescription"></p>
                                <div className="permission_area role_options">

                                    {Object.keys(groupedPermissions).map((groupName) => (

                                        <div key={groupName} className="options fullwidth">

                                            <h4 className="module_title">
                                                {groupName.toUpperCase()}
                                            </h4>

                                            {groupedPermissions[groupName].map((perm) => {

                                                const isChecked = assignedPermissions.includes(perm.id);

                                                return (
                                                    <div key={perm.id} className="permission_item">
                                                        <label>
                                                            <span><i className='ri-arrow-drop-right-fill'></i></span>
                                                            <input
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                disabled={perm.is_system_permission === 1}
                                                                onChange={() => togglePermission(perm.id)}
                                                            />
                                                            &nbsp;{perm.description}
                                                        </label>
                                                    </div>
                                                );
                                            })}

                                        </div>

                                    ))}

                                </div>

                            </div>
                        </div>
                        <div className='vl_dsh_one_third mt-50'>
                            <div className='role_options mt-30 mb-30'>
                                <h3>Important Info</h3>
                                <p>You cannot set permissions for Super Admin. Super admin can access each and every section of this application</p>
                                <p>All users can access basic features like Goals, My Tasks, Daily Reports, Inbox, Meeting Room, Time Sheet (own), Project (related only).</p>
                            </div>
                        </div>
                    </div>
                    <div className='vl_dsh_one_row'>
                        <div className='vl_dsh_two_third mt-20'>
                            <div className='fullwidth text_right pull_left'>
                                <button className='editbtn' onClick={savePermissions}>Save Role Settings</button>
                            </div>
                        </div>
                        <div className='vl_dsh_one_third mt-20'>

                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
